const pageData = [
  {
    order: 1,
    title: "Driven",
    heading: "Driven",
    subheading:
      "Vill du ha någon som är snabb på att räcka upp handen eller som kör sitt eget race?",
    dl1:
      "Ordet driven är särskilt vanligt inom säljyrken. Men det beskrivs sällan vad man gör när man är driven.",
    navTitle: "Se hur du kan formulera dig tydligare!",
    link: "/driven/"
  },
  {
    order: 2,
    title: "Quiz",
    heading: "Driven",
    subheading:
      "Man kan vara driven att göra karriär, men vilket beteende skapar värde hos er?",
    link: "/driven/02/",
    quizHeading: "",
    quizAnswer1: {
      content: "Lägger tid på att följa upp och nå mål",
      note: "Prioriteringskompetens"
    },
    quizAnswer2: {
      content: "Startar och driver förändringsarbete",
      note: "Utvecklingskompetens"
    },
    quizAnswer3: {
      content: "Arbetar uthålligt över tid",
      note: "Organiseringskompetens"
    },
    quizAnswer4: {
      content: "Övertygar andra att förändra ståndpunkt eller handlingssätt",
      note: "Relationskompetens"
    },
    modal: {
      heading: "Driven",
      subheading: "Härligt!",
      body: "Nu kan du uttrycka dig mer unikt.",
      buttonText: "Fortsätt jakten!"
    }
  }
];

export default pageData;



// WEBPACK FOOTER //
// ./src/data/driven.js